import { configureStore } from "@reduxjs/toolkit";
import slideReducer from "./slices/slides";
import assessmentReducer from "./slices/assessment";
import uiReducer from "./slices/ui";

export default configureStore({
  reducer: {
    slides: slideReducer,
    assessment: assessmentReducer,
    ui: uiReducer,
  },
});
